import { Card } from 'antd'
import { EXPLORER_BORDER_GRAY_LOW_OPACITY } from 'features/drilldown'
import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'

export interface StatDisplayContainerProps {
  isLoading?: boolean
  children: ReactNode
  title?: string
}

const CardBodyContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
`

const STAT_DISPLAY_CONTAINER_STYLE: React.CSSProperties = {
  width: '12rem',
}

export const StatDisplayContainer: FC<StatDisplayContainerProps> = ({
  children,
  isLoading,
  title,
}) => {
  return (
    <Card
      title={title}
      style={STAT_DISPLAY_CONTAINER_STYLE}
      loading={isLoading}
      variant='borderless'
      styles={{
        header: {
          paddingLeft: '15px',
          paddingRight: '15px',
          minHeight: '3rem',
          border: `1px solid ${EXPLORER_BORDER_GRAY_LOW_OPACITY}`,
          borderBottom: `0px`,
        },
        body: {
          padding: '5px',
          border: `1px solid ${EXPLORER_BORDER_GRAY_LOW_OPACITY}`,
        },
      }}>
      <CardBodyContainer>{children}</CardBodyContainer>
    </Card>
  )
}
